import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataProtection } from '@aptsi-types';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandlingService } from 'src/app/shared/errorHandling/errorHandling.service';
import { API_ENDPOINTS } from '../../data-protection-api-endpoints';

export interface SecurityZoneSystemAssets{
  securityZoneId: string,
  systemAssetId: string
}

@Injectable({
  providedIn: 'root'
})
export class DataAssetMappingService {
  private readonly dataAssetMappingsUrl = environment.apiUrl;

  constructor(private http: HttpClient, private errorHandlingService: ErrorHandlingService) { }


   FetchDataAssetsWithMappingStatus(
      currentPage: number
    ): Observable<DataProtection[]> {
      return this.http
        .post<DataProtection[]>(
          `${this.dataAssetMappingsUrl}${API_ENDPOINTS.DATAASSETMAPPINGS.FETCH_DATA_ASSETS_WITH_MAPPING_STATUS}`,
          { currentPage }
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }

       FetchDataAssetsWithMappingStatusSearch(
      currentPage: number, searchText: String, filterByHeader: String,
    ): Observable<DataProtection[]> {
      return this.http
        .post<DataProtection[]>(
          `${this.dataAssetMappingsUrl}${API_ENDPOINTS.DATAASSETMAPPINGS.FETCH_DATA_ASSETS_WITH_MAPPING_STATUS_SEARCH}`,
          { currentPage, searchText, filterByHeader }
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }

    FetchSystemAssetsForMapping(
     currentPage: number,  securityZoneIds: string[]
    ): Observable<DataProtection[]> {
      return this.http
        .post<DataProtection[]>(
          `${this.dataAssetMappingsUrl}${API_ENDPOINTS.DATAASSETMAPPINGS.FETCH_SYSTEM_ASSETS_FOR_MAPPING}`,
          { currentPage,
            securityZoneIds,
             }
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }

        FetchSystemAssetsForMappingSearch(
      currentPage: number, searchText: String, filterByHeader: String, securityZoneIds: string[]
    ): Observable<DataProtection[]> {
      return this.http
        .post<DataProtection[]>(
          `${this.dataAssetMappingsUrl}${API_ENDPOINTS.DATAASSETMAPPINGS.FETCH_SYSTEM_ASSETS_FOR_MAPPING_SEARCH}`,
          { currentPage , searchText,
            filterByHeader,securityZoneIds}
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }

        FetchSecurityZones(
      currentPage: number
    ): Observable<DataProtection[]> {
      return this.http
        .post<DataProtection[]>(
          `${this.dataAssetMappingsUrl}${API_ENDPOINTS.DATAASSETMAPPINGS.FETCH_SECURITY_ZONES}`,
          { currentPage }
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }

        FetchSecurityZonesSearch(
      currentPage: number, searchText: String, filterByHeader: String
    ): Observable<DataProtection[]> {
      return this.http
        .post<DataProtection[]>(
          `${this.dataAssetMappingsUrl}${API_ENDPOINTS.DATAASSETMAPPINGS.FETCH_SECURITY_ZONES_SEARCH}`,
          { currentPage,
            searchText,
            filterByHeader
           }
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }

    FetchMappingDetailsByDataAssetId(dataAssetId: string): Observable<DataProtection[]> {
      return this.http
        .post<DataProtection[]>(
          `${this.dataAssetMappingsUrl}${API_ENDPOINTS.DATAASSETMAPPINGS.FETCH_MAPPING_DETAILS_BY_DATA_ASSET_ID}`,
          { dataAssetId}
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }

        createMapping(dataAssetId:string, mappingName: string, mappingDescription:string, mappingCreatedBy:string, mappingCreatedByKeycloakId: string , systemAssetIds:string[], securityZoneIds:string[] , securityZoneSystemAssets: SecurityZoneSystemAssets[]): Observable<DataProtection[]> {
      return this.http
        .post<DataProtection[]>(
          `${this.dataAssetMappingsUrl}${API_ENDPOINTS.DATAASSETMAPPINGS.CREATE_MAPPING}`,
          { dataAssetId,
            mappingName,
            mappingDescription,
            mappingCreatedBy,
            mappingCreatedByKeycloakId,
            systemAssetIds,
            securityZoneIds,
            securityZoneSystemAssets
           }
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }

        UpdateMapping(mappingId: string, mappingDescription:string,systemAssetIds: string[],securityZoneIds: string[], securityZoneSystemAssets: SecurityZoneSystemAssets[]): Observable<DataProtection[]> {
      return this.http
        .post<DataProtection[]>(
          `${this.dataAssetMappingsUrl}${API_ENDPOINTS.DATAASSETMAPPINGS.UPDATE_MAPPING}`,
          {   
            mappingId,
            mappingDescription,
            systemAssetIds,
            securityZoneIds,
            securityZoneSystemAssets }
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }




    FetchMappedSystemAssetsByDataAssetId(currentPage: number, dataAssetId:string) {
      return this.http
        .post<DataProtection[]>(
          `${this.dataAssetMappingsUrl}${API_ENDPOINTS.DATAASSETMAPPINGS.FETCH_MAPPED_SYSTEM_ASSETS_BY_DATA_ASSET_ID}`,
          { currentPage, dataAssetId}
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }


    FetchMappedSystemAssetsByDataAssetIdSearch(  currentPage: number, searchText: String, filterByHeader: String, dataAssetId:string) {
      return this.http
        .post<DataProtection[]>(
          `${this.dataAssetMappingsUrl}${API_ENDPOINTS.DATAASSETMAPPINGS.FETCH_MAPPED_SYSTEM_ASSETS_BY_DATA_ASSET_ID_SEARCH}`,
          { currentPage, searchText, filterByHeader, dataAssetId}
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }

        FetchMappedSecurityZonesByDataAssetId(currentPage: number, dataAssetId:string) {
      return this.http
        .post<DataProtection[]>(
          `${this.dataAssetMappingsUrl}${API_ENDPOINTS.DATAASSETMAPPINGS.FETCH_MAPPED_SECURITY_ZONES_BY_DATA_ASSET_ID}`,
          { currentPage, dataAssetId  }
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }

            FetchMappedSecurityZonesByDataAssetIdSearch(currentPage: number, searchText: String, filterByHeader: String, dataAssetId:string) {
      return this.http
        .post<DataProtection[]>(
          `${this.dataAssetMappingsUrl}${API_ENDPOINTS.DATAASSETMAPPINGS.FETCH_MAPPED_SECURITY_ZONES_BY_DATA_ASSET_ID_SEARCH}`,
          { currentPage, searchText, filterByHeader, dataAssetId }
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }

      FetchMappedPartialSecurityZonesByDataAssetId( dataAssetId:string) {
      return this.http
        .post<DataProtection[]>(
          `${this.dataAssetMappingsUrl}${API_ENDPOINTS.DATAASSETMAPPINGS.FETCH_MAPPED_PARTIAL_SECURITY_ZONES_BY_DATA_ASSET_ID}`,
          { dataAssetId  }
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }



        FetchSystemAssetsBySecurityZoneId(currentPage: number, securityZoneId: string) {
      return this.http
        .post<DataProtection[]>(
          `${this.dataAssetMappingsUrl}${API_ENDPOINTS.DATAASSETMAPPINGS.FETCH_SYSTEM_ASSETS_BY_SECURITY_ZONE_ID}`,
          { currentPage, securityZoneId  }
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }

        FetchSystemAssetsBySecurityZoneIdSearch(currentPage: number, searchText: String, filterByHeader: String, securityZoneId: string) {
      return this.http
        .post<DataProtection[]>(
          `${this.dataAssetMappingsUrl}${API_ENDPOINTS.DATAASSETMAPPINGS.FETCH_SYSTEM_ASSETS_BY_SECURITY_ZONE_ID_SEARCH}`,
          { currentPage, searchText, filterByHeader, securityZoneId  }
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }
      

} 